import type {
  ProductBenefitBannersResponse,
  BadgesResponse,
} from '@/api/directus/queries';
import type {AxiosResponse} from 'axios';

import axios from 'axios';

import {productBenefitBanners, badges} from '@/api/directus/queries';

export type SeaCampaignResponse = {
  data: ProductBenefitBannersResponse & BadgesResponse;
};

export const seaCampaign = async ({
  abortSignal,
}: {
  abortSignal?: AbortSignal;
}) => {
  const response = await axios<
    SeaCampaignResponse,
    AxiosResponse<SeaCampaignResponse>
  >({
    method: 'post',
    url: import.meta.env.VITE_SERVICE_DIRECTUS_URL,
    data: {
      query: `query SeaCampaign {
        ${productBenefitBanners()}
        ${badges()}
      }`,
    },
    signal: abortSignal,
  });

  return response.data;
};
